import { LitElement, html, css } from 'lit';

class SkgElement extends LitElement {
    static styles = css`
        .skg-container {
            width: 100%;
            margin-top: 1em;
            margin-bottom: 1em;
            margin-left: -1em;
            margin-right: -1em;
            padding: 1em;
            background-color: #FFF;
            color:#000;
            border: 1px solid rgb(25, 118, 210);
            border-radius: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2em;        
        }
        .skg-container img {
            display: none;
        }
        @media only screen and (min-width: 920px) {
            .skg-container {
                width: 100%;
                flex-direction: row;
                border-radius: 0.25em;
            }
            .skg-container img {
                display: block;
            }
        }
        .skg-text-container {
            display: flex;
            flex-direction: column;
        }
        .skg-btn-wrapper {
            display: flex;
            flex-direction: row;
            gap: 1em;
        }
        .skg-btn-style {
            display: inline-block;
            background-color: #FFF;
            border: 4px solid rgb(25, 118, 210);
            color:rgb(25, 118, 210);
            font-weight:bold;
            padding: 1em;
            border-radius: 0.25em;
            text-decoration: none;
            cursor: pointer;
        }
        .skg-btn-style--inverse {
            display: inline-block;
            background-color:  rgb(25, 118, 210);
            border: 4px solid rgb(25, 118, 210);
            color:#FFF;
            font-weight:bold;
            padding: 1em;
            border-radius: 0.25em;
            text-decoration: none;
            cursor: pointer;
        }
    `;

    static properties = {
        isShown: {state: true, type: Boolean, reflect: true},
        eu: {
            type: Boolean,
            hasChanged(newVal, oldVal) {
              return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' || value === true) {
                        return true;
                    }
                    if (value === 'false' || value === 'False' || value == '0' || value === false ) {
                        return false;
                    }
                    return false;
                }
            }
        }
    };
    constructor() {
        super();
        this.loadVisibilityState();
    }

    // Load the visibility state from local storage
    loadVisibilityState() {
        let storedState = localStorage.getItem('skg-element-hidden');
        if (storedState === null) {
            localStorage.setItem('skg-element-hidden', 'false');
            storedState = 'false';
        }
        this.isShown = storedState === 'false';
    }

    // Toggle the visibility state and update local storage
    toggleVisibility() {
        this.isShown = !this.isShown;
        localStorage.setItem('skg-element-hidden', 'true');
    }

    render() {
        return html`
            ${this.isShown ? html`
                <div class="skg-container">
                    <img src="https://s3.eu-central-1.wasabisys.com/open3dlab-static/img/skglogo.png" alt="Stop Killing Games campaign logo" style="flex-grow:0; max-height: 150px;"/>
                    <div class="skg-text-container">
                        ${this.eu ? html`<p><strong>We need your help, EU citizen! 🇪🇺 Please sign the <a href="https://eci.ec.europa.eu/045/public" style="color:rgb(25, 118, 210);">European Citizens' Initiative to preserve videogames</a>!</strong></p>`: html`<p><strong>Hey there, gamer! Please help spread the word about the European Citizens' Initiative to preserve videogames!</strong></p>`}
                        <p>Here at Open3DLab we believe in the preservation of games, and oppose the use of invasive DRM. Self-hosted, custom servers are replaced with monolithic services that can be turned off permanently by game publishers. <strong>Even when you paid for the game or in-game items, you can no longer play it.</strong> We think this is unacceptable.</p>
                        <p>This citizen's initiative is a first step towards protecting our rights as players. And you can help make a difference. So please, <strong>if you are an EU citizen, please sign the petition</strong>. And convince your friends to do the same.</p>
                        <div class="skg-btn-wrapper">
                            ${this.eu ? html`<a href="https://eci.ec.europa.eu/045/public" class="skg-btn-style--inverse">Sign the Initiative</a>` : html``}
                            <a href="https://www.stopkillinggames.com/" class="skg-btn-style">More information</a>
                            <button @click="${this.toggleVisibility}" class="skg-btn-style">Close this message</button>
                        </div>
                    </div>
                </div>
            ` : ''}
        `;
    }
}

window.customElements.define('skg-element', SkgElement);